export const VERTEX = /* glsl */ `
  #include <common>
  #include <skinning_pars_vertex>

  uniform float uThickness;

  void main() {
    // Inverted-hull technique: displace vertex along its normal by uThickness.
    #include <skinbase_vertex>
    #include <begin_vertex>
    transformed += normalize(normal) * uThickness;
    #include <skinning_vertex>
    #include <project_vertex>
  }
`;
export const FRAGMENT = /* glsl */ `
  uniform vec3 uColor;
  void main() {
    gl_FragColor = vec4(uColor, 1.0);
  }
`;
